import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=558b7594&scoped=true&"
var script = {}
import style0 from "./Card.vue?vue&type=style&index=0&id=558b7594&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558b7594",
  null
  
)

export default component.exports